<p-dialog
  [(visible)]="visivel"
  [header]="cabecalho"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="confirm-popup-dialog"
  [style]="{ width: '550px' }">

  <div class="confirm-popup-body">
    <span [innerHTML]="mensagem"></span>
  </div>

  <ng-template pTemplate="footer">
    <div class="confirm-popup-footer">
      <div class="confirm-popup-footer-start">
        <button type="button" *ngIf="!!legendaCancelar" class="o-button -white" (click)="cancelar()">{{ legendaCancelar }}</button>
      </div>
      <div class="confirm-popup-footer-end">
        <button type="button" class="o-button -white" (click)="onRejeitar()">{{ legendaRejeitar }}</button>
        <button type="button" class="o-button -blue" (click)="onConfirmar()">{{ legendaConfirmar }}</button>
      </div>
    </div>
  </ng-template>

</p-dialog>
